import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { ViewGridIcon } from '@heroicons/react/outline';
import './styles.scss';
import { config } from '../../utils/config';
import { setAuthHeader } from '../../api/api'
import { hasInteractAdminLicense } from '../../utils/license';
import { signInReturnPath } from '../../utils/oidcUtilities';
import { useReactOidc } from '../../hooks/useReactOidc';

import { TailwindUiContext } from '../../contexts';
import { TwNavBar } from "../../components/TailwinNavBar";
import { tailwindUiSettings } from '../../tailwindUiSettings.js';

const Oidc = () => {
  const navigate = useNavigate();
  const { oidcUser } = useReactOidc();

  useEffect(() => {
    if (oidcUser) {
      setAuthHeader(oidcUser.access_token)
      validateLicense()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oidcUser])

  // fontawesome icons not supported at the moment in the TwNavBar component
  const navigation = [
    { /*icon: faHome,*/ name: 'Dashboard', route: `/`, featureEnabled: true },
  ]


  const userNavigation = [
    { name: "Your Profile", href: "#" },
    { name: "Settings", href: "#" },
    /* { name: "Change Company", onClick: changeCompany },
    { name: "Sign out", href: "#", onClick: logout }, */
  ];



  const validateLicense = async () => {
    if (!(await hasInteractAdminLicense())) {
      navigate('/missing-license');
    } else {
      // The library has already restored the page sign-in started from (redirect_uri's own
      // history handling never goes through the router); this only moves off the callback
      // page itself, which signInReturnPath resolves to home.
      navigate(signInReturnPath(), { replace: true });
    }
  }

  const GridIconSendBaseUrl = () => (
    <a href={config.centerpointUiBaseUrl} rel="noreferrer" target="_blank" className={""}>
      <ViewGridIcon className="h-8 w-auto text-gray-800 hover:text-gray-600 cursor-pointer" />
    </a>
  )

  return (
    <TailwindUiContext.Provider value={tailwindUiSettings}>
      <div className="relative min-h-screen flex flex-col bg-white dark:bg-gray-900">
        <TwNavBar navigation={navigation} userNavigation={userNavigation} helpUrl={config.docsUrl} />

        <main className="main-container bg-brand-background flex-1 z-0 focus:outline-none dark:bg-gray-800">
          <div className={`${tailwindUiSettings.fullwidth ? "max-w-screen-3xl" : "max-w-screen-3xl"} h-full mx-auto inset-0 py-6 px-4 sm:px-6 lg:px-8`}>
            <div className="flex flex-col pb-10 h-full">
              <div className={`${tailwindUiSettings.fullwidth ? "max-w-screen-3xl" : "max-w-screen-3xl"} h-full`}>
                <p className="text-2xl font-bold mt-6 dark:text-white">Loading...</p>
              </div>
            </div>
          </div>
        </main>
      </div>
    </TailwindUiContext.Provider>
  )
}

export default Oidc;
